import { useState } from 'react';
import { OnboardingEye } from '../Eye';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { SequenceItem } from './OnboardingProjectSequence';
import InputBar from '../InputBar';
import BPInput from '../../BionicUI/input/BPInput';
import useOnboardingProjectStore from 'stores/onboardingProjectStore';
// import { PostUserSocialRequest } from 'core/models/users/socials/post-user-social.model';
// import { SocialNetworkType } from 'core/models/users/socials/user-social.model';
// import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';

const XAccount = () => {
  const [showInputBar, setShowInputBar] = useState<boolean>(false);
  const { nextStep, setProgressStep, setProjectInfo, projectInfo } =
    useOnboardingProjectStore();

  async function handleSubmit(inputText: string | null | undefined) {
    if (!inputText) return;
    setProjectInfo('xUsername', inputText);
    nextStep();
  }

  return (
    <SequenceItem>
      <div className="flex justify-center w-full max-w-[800px] px-6 gap-[20px] mx-auto items-start">
        <OnboardingEye />
        <BPInstruction
          line1={{
            text: 'Please enter the X.com username for your project, if you have one.',
            sound: 'projectStep/please-enter-x-com-username.mp3',
          }}
          onAnimComplete={() => setShowInputBar(true)}
        ></BPInstruction>
      </div>
      {showInputBar && (
        <InputBar onClickBackButton={() => setProgressStep(3)}>
          <BPInput
            value={projectInfo.xUsername}
            state="default"
            type="text"
            isX
            placeholder="Enter project X username"
            button={{
              state: 'primary',
              onClick: (e, inputText) => handleSubmit(inputText),
              title: 'Submit',
            }}
            validate={(text) => text.length > 3}
          />
        </InputBar>
      )}
    </SequenceItem>
  );
};

export default XAccount;
